<template>
	<div id="home">
		<section class="hero is-fullheight fitco landing has-navbar-fixed-top">
			<div class="hero-head">
				<navigation></navigation>
			</div>
			<div class="hero-body">
				<div class="container is-fluid has-text-centered">
					<figure class="image large" style="margin: auto">
						<img src="~@/assets/logo/titlelogo.png" />
					</figure>
					<router-link
						to="/contact"
						class="button is-medium is-primary is-outlined thick is-rounded"
						style="font-weight: 700; color: white"
						>Let's Talk<span class="wave">👋</span></router-link
					>
				</div>
			</div>
			<div class="hero-foot">
				<div class="container has-text-centered">
					<span class="down"></span>
				</div>
			</div>
		</section>
		<section class="hero is-medium is-white">
			<div class="hero-body">
				<div class="container">
					<div class="columns is-8">
						<div class="column">
							<h1 class="is-title has-text-dark">
								We create an organizational culture of wellness.
							</h1>
							<h2 class="is-subtitle has-text-dark">
								Your health in our hands
							</h2>
							<p class="subtitle is-5">
								FitCo Wellness Solutions provides wellness tools that extend
								beyond traditional programs for companies to actively address
								occupational health hazards due to high stress, workplace
								ergonomics, and a sedentary lifestyle.
							</p>
						</div>
						<div class="column">
							<figure class="image is-4by3">
								<img style="margin: auto" src="@/assets/image/people.jpg" />
							</figure>
						</div>
					</div>
				</div>
			</div>
		</section>
		<section class="hero is-white">
			<div class="hero-body">
				<div class="container">
					<h1 class="is-title has-text-dark">
						See what our clients have to say
					</h1>
					<success></success>
				</div>
			</div>
		</section>
		<section class="hero is-fullheight fitco meet">
			<div class="hero-body">
				<div class="container">
					<h1
						class="title strong is-2"
						style="color: rgba(255, 255, 255, 0.85)"
					>
						Cooporate wellness is <span class="fitco-underline">more</span> than
						just physical fitness.
					</h1>
					<p class="subtitle has-text-white">
						Our program has been devised to provide a healthy, happy, and
						productive company culture and to save your company time and money.
						We accomplish this by offering the following services to all
						employees
					</p>
					<br />
					<div class="columns">
						<div class="column">
							<div class="card fitco-card card-1">
								<div class="card-content has-text-white">
									<h1 class="title has-text-white fitco-underline">Physical</h1>
									<br />
									<p class="subtitle is-5 has-text-white">
										Ergonomic improvement processes, LIVE virtual workouts and
										on demand classes, daily steps challenges, nutrition challenges, smoking
										cessation, weight loss, and community drives
									</p>
								</div>
							</div>
						</div>
						<div class="column">
							<div class="card fitco-card card-2">
								<div class="card-content has-text-white">
									<h1 class="title has-text-white fitco-underline">Mental</h1>
									<br />
									<p class="subtitle is-5 has-text-white">
										Lunch and learn health education providing discussions and
										seminars on all aspects of wellness
									</p>
								</div>
							</div>
						</div>
						<div class="column">
							<div class="card fitco-card card-3">
								<div class="card-content has-text-white">
									<h1 class="title has-text-white fitco-underline">
										Emotional
									</h1>
									<br />
									<p class="subtitle is-5 has-text-white">
										Yoga classes (LIVE and on demand), meditation information
										and guidance, stress management, motivational texts
									</p>
								</div>
							</div>
						</div>
					</div>
					<br />
					<div class="has-text-centered">
						<router-link
							to="/programs"
							class="button is-medium is-primary is-outlined thick is-rounded"
							style="font-weight: 700; color: white"
							>Find out more</router-link
						>
					</div>
				</div>
			</div>
			<div class="hero-foot">
				<div class="container has-text-centered">
					<span class="down is-hidden-touch"></span>
				</div>
			</div>
		</section>
		<section class="hero is-primary is-medium">
			<div class="hero-body">
				<div class="container">
					<div class="columns is-vcentered">
						<div class="column">
							<h1 class="title is-1 has-text-dark">
								Like what you see? Your healthy company culture is a click away.
							</h1>
							<h2 class="subtitle is-3 has-text-dark">
								Find out what we can do for you!
							</h2>
							<br />
							<router-link
								to="/contact"
								class="button is-large is-dark is-outlined thick is-rounded"
								style="font-weight: 700"
								>Schedule a Demo</router-link
							>
						</div>
						<div class="column"></div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import navigation from "@/components/navigation.vue";
import success from "@/components/misc/success";

export default {
	components: { navigation, success },
};
</script>